import React, { createContext, useContext } from 'react';

interface AnalyticsPropertyProviderProps {
    property: string | undefined;
}

interface AnalyticsPropertyContextType {
    property: string | undefined;
}

const AnalyticsPropertyContext = createContext<
    AnalyticsPropertyContextType | undefined
>(undefined);

export const AnalyticsPropertyProvider: React.FC<
    AnalyticsPropertyProviderProps
> = ({ property, children }) => {
    return (
        <AnalyticsPropertyContext.Provider value={{ property }}>
            {children}
        </AnalyticsPropertyContext.Provider>
    );
};

export const useAnalyticsProperty = (): AnalyticsPropertyContextType => {
    const context = useContext(AnalyticsPropertyContext);
    if (context === undefined) {
        throw new Error(
            'useAnalyticsProperty must be used within an AnalyticsPropertyProvider'
        );
    }
    return context;
};
